"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceApi = exports.ServiceApiFactory = exports.ServiceApiFp = exports.ServiceApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
const common_1 = require("../common");
const base_1 = require("../base");
const ServiceApiAxiosParamCreator = function (configuration) {
    return {
        addCustomUnitLabelSubtasksForJob: async (dpId, customUnitLabelSubtaskRequest, options = {}) => {
            (0, common_1.assertParamExists)("addCustomUnitLabelSubtasksForJob", "dpId", dpId);
            (0, common_1.assertParamExists)("addCustomUnitLabelSubtasksForJob", "customUnitLabelSubtaskRequest", customUnitLabelSubtaskRequest);
            const localVarPath = `/v1/custom-unit-labels/{dpId}`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customUnitLabelSubtaskRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        addFloorLoadedContainerForSourceTypeAndId: async (sourceType, sourceId, floorLoadedContainerRequest, options = {}) => {
            (0, common_1.assertParamExists)("addFloorLoadedContainerForSourceTypeAndId", "sourceType", sourceType);
            (0, common_1.assertParamExists)("addFloorLoadedContainerForSourceTypeAndId", "sourceId", sourceId);
            (0, common_1.assertParamExists)("addFloorLoadedContainerForSourceTypeAndId", "floorLoadedContainerRequest", floorLoadedContainerRequest);
            const localVarPath = `/v1/floor-loaded-container/source/{sourceType}/{sourceId}`
                .replace(`{${"sourceType"}}`, encodeURIComponent(String(sourceType)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(floorLoadedContainerRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        addKitsByShippingPlan: async (sellerId, shippingPlanId, options = {}) => {
            (0, common_1.assertParamExists)("addKitsByShippingPlan", "sellerId", sellerId);
            (0, common_1.assertParamExists)("addKitsByShippingPlan", "shippingPlanId", shippingPlanId);
            const localVarPath = `/v1/kitting/automatic/seller/{sellerId}/shipping-plan/{shippingPlanId}`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
                .replace(`{${"shippingPlanId"}}`, encodeURIComponent(String(shippingPlanId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        addKitsToJob: async (dpId, kittingRequest, options = {}) => {
            (0, common_1.assertParamExists)("addKitsToJob", "dpId", dpId);
            (0, common_1.assertParamExists)("addKitsToJob", "kittingRequest", kittingRequest);
            const localVarPath = `/v1/kitting/prep-job/{dpId}`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(kittingRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        addPrepTypesToJob: async (prepJobRequest, options = {}) => {
            (0, common_1.assertParamExists)("addPrepTypesToJob", "prepJobRequest", prepJobRequest);
            const localVarPath = `/v1/prep-job`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(prepJobRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        archiveFacilityJobLocation: async (facilityId, location, options = {}) => {
            (0, common_1.assertParamExists)("archiveFacilityJobLocation", "facilityId", facilityId);
            (0, common_1.assertParamExists)("archiveFacilityJobLocation", "location", location);
            const localVarPath = `/v1/facility/{facilityId}/job-location/{location}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"location"}}`, encodeURIComponent(String(location)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "DELETE" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        archivePrepJob: async (dpId, options = {}) => {
            (0, common_1.assertParamExists)("archivePrepJob", "dpId", dpId);
            const localVarPath = `/v1/prep-job/{dpId}`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "DELETE" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        batchManualBilling: async (manualBillingRequest, options = {}) => {
            (0, common_1.assertParamExists)("batchManualBilling", "manualBillingRequest", manualBillingRequest);
            const localVarPath = `/v1/billing`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(manualBillingRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        completeBoxBuild: async (dpId, completeBoxBuildRequest, options = {}) => {
            (0, common_1.assertParamExists)("completeBoxBuild", "dpId", dpId);
            (0, common_1.assertParamExists)("completeBoxBuild", "completeBoxBuildRequest", completeBoxBuildRequest);
            const localVarPath = `/v1/box-build/prep-job/{dpId}/complete`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(completeBoxBuildRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        completeKitFromJob: async (dpId, kittingUuid, kittingCompletionRequest, options = {}) => {
            (0, common_1.assertParamExists)("completeKitFromJob", "dpId", dpId);
            (0, common_1.assertParamExists)("completeKitFromJob", "kittingUuid", kittingUuid);
            (0, common_1.assertParamExists)("completeKitFromJob", "kittingCompletionRequest", kittingCompletionRequest);
            const localVarPath = `/v1/kitting/{kittingUuid}/prep-job/{dpId}/complete`
                .replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)))
                .replace(`{${"kittingUuid"}}`, encodeURIComponent(String(kittingUuid)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(kittingCompletionRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        completePrepJob: async (dpId, completePrepJobRequest, options = {}) => {
            (0, common_1.assertParamExists)("completePrepJob", "dpId", dpId);
            (0, common_1.assertParamExists)("completePrepJob", "completePrepJobRequest", completePrepJobRequest);
            const localVarPath = `/v1/prep-job/{dpId}/complete`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(completePrepJobRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        completePrepTask: async (dpId, completePrepTaskRequest, options = {}) => {
            (0, common_1.assertParamExists)("completePrepTask", "dpId", dpId);
            (0, common_1.assertParamExists)("completePrepTask", "completePrepTaskRequest", completePrepTaskRequest);
            const localVarPath = `/v1/prep-job/{dpId}/task/complete`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(completePrepTaskRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createBarcodeTranslationMap: async (sellerId, createBarcodeTranslationMapRequest, options = {}) => {
            (0, common_1.assertParamExists)("createBarcodeTranslationMap", "sellerId", sellerId);
            (0, common_1.assertParamExists)("createBarcodeTranslationMap", "createBarcodeTranslationMapRequest", createBarcodeTranslationMapRequest);
            const localVarPath = `/v1/barcode-translation/{sellerId}`.replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createBarcodeTranslationMapRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createFacilityJobLocation: async (facilityId, facilityJobLocationRequest, options = {}) => {
            (0, common_1.assertParamExists)("createFacilityJobLocation", "facilityId", facilityId);
            (0, common_1.assertParamExists)("createFacilityJobLocation", "facilityJobLocationRequest", facilityJobLocationRequest);
            const localVarPath = `/v1/facility/{facilityId}/job-location`.replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(facilityJobLocationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        downloadBoxContentLabels: async (dpId, boxConfigurationUuid, labelFormat, options = {}) => {
            (0, common_1.assertParamExists)("downloadBoxContentLabels", "dpId", dpId);
            (0, common_1.assertParamExists)("downloadBoxContentLabels", "boxConfigurationUuid", boxConfigurationUuid);
            (0, common_1.assertParamExists)("downloadBoxContentLabels", "labelFormat", labelFormat);
            const localVarPath = `/v1/box-configuration/{boxConfigurationUuid}/prep-job/{dpId}/labels`
                .replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)))
                .replace(`{${"boxConfigurationUuid"}}`, encodeURIComponent(String(boxConfigurationUuid)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (labelFormat !== undefined) {
                localVarQueryParameter["labelFormat"] = labelFormat;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        enableLotFefoForUnitLabels: async (dpId, options = {}) => {
            (0, common_1.assertParamExists)("enableLotFefoForUnitLabels", "dpId", dpId);
            const localVarPath = `/v1/unit-labels/prep-job/{dpId}/lot-fefo`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        finalizeBoxConfiguration: async (dpId, boxConfigurationUuid, boxConfigurationFinalizationRequest, options = {}) => {
            (0, common_1.assertParamExists)("finalizeBoxConfiguration", "dpId", dpId);
            (0, common_1.assertParamExists)("finalizeBoxConfiguration", "boxConfigurationUuid", boxConfigurationUuid);
            (0, common_1.assertParamExists)("finalizeBoxConfiguration", "boxConfigurationFinalizationRequest", boxConfigurationFinalizationRequest);
            const localVarPath = `/v1/box-configuration/{boxConfigurationUuid}/prep-job/{dpId}/finalize`
                .replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)))
                .replace(`{${"boxConfigurationUuid"}}`, encodeURIComponent(String(boxConfigurationUuid)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(boxConfigurationFinalizationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generatePDFBarcodeTranslation: async (dpId, barcodeTranslationUuid, printUnitLabelRequest, options = {}) => {
            (0, common_1.assertParamExists)("generatePDFBarcodeTranslation", "dpId", dpId);
            (0, common_1.assertParamExists)("generatePDFBarcodeTranslation", "barcodeTranslationUuid", barcodeTranslationUuid);
            (0, common_1.assertParamExists)("generatePDFBarcodeTranslation", "printUnitLabelRequest", printUnitLabelRequest);
            const localVarPath = `/v1/barcode-translation/{barcodeTranslationUuid}/prep-job/{dpId}/labels/pdf`
                .replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)))
                .replace(`{${"barcodeTranslationUuid"}}`, encodeURIComponent(String(barcodeTranslationUuid)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(printUnitLabelRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generatePDFUnitLabels: async (dpId, uuid, labelFormat, quantity, options = {}) => {
            (0, common_1.assertParamExists)("generatePDFUnitLabels", "dpId", dpId);
            (0, common_1.assertParamExists)("generatePDFUnitLabels", "uuid", uuid);
            const localVarPath = `/v1/unit-labels/prep-job/{dpId}/{uuid}/pdf`
                .replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (labelFormat !== undefined) {
                localVarQueryParameter["labelFormat"] = labelFormat;
            }
            if (quantity !== undefined) {
                localVarQueryParameter["quantity"] = quantity;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateZPLBarcodeTranslation: async (dpId, barcodeTranslationUuid, printUnitLabelRequest, options = {}) => {
            (0, common_1.assertParamExists)("generateZPLBarcodeTranslation", "dpId", dpId);
            (0, common_1.assertParamExists)("generateZPLBarcodeTranslation", "barcodeTranslationUuid", barcodeTranslationUuid);
            (0, common_1.assertParamExists)("generateZPLBarcodeTranslation", "printUnitLabelRequest", printUnitLabelRequest);
            const localVarPath = `/v1/barcode-translation/{barcodeTranslationUuid}/prep-job/{dpId}/labels`
                .replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)))
                .replace(`{${"barcodeTranslationUuid"}}`, encodeURIComponent(String(barcodeTranslationUuid)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(printUnitLabelRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateZPLUnitLabels: async (dpId, uuid, labelFormat, quantity, options = {}) => {
            (0, common_1.assertParamExists)("generateZPLUnitLabels", "dpId", dpId);
            (0, common_1.assertParamExists)("generateZPLUnitLabels", "uuid", uuid);
            const localVarPath = `/v1/unit-labels/prep-job/{dpId}/{uuid}/zpl`
                .replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (labelFormat !== undefined) {
                localVarQueryParameter["labelFormat"] = labelFormat;
            }
            if (quantity !== undefined) {
                localVarQueryParameter["quantity"] = quantity;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBoxConfigurations: async (dpId, options = {}) => {
            (0, common_1.assertParamExists)("getBoxConfigurations", "dpId", dpId);
            const localVarPath = `/v1/box-configuration/prep-job/{dpId}/box-configuration`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCartonLabelDownloadUrl: async (dpId, type, name, options = {}) => {
            (0, common_1.assertParamExists)("getCartonLabelDownloadUrl", "dpId", dpId);
            (0, common_1.assertParamExists)("getCartonLabelDownloadUrl", "type", type);
            const localVarPath = `/v1/carton-label/prep-job/{dpId}/url`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter["type"] = type;
            }
            if (name !== undefined) {
                localVarQueryParameter["name"] = name;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCustomUnitLabelSubtasksForJob: async (dpId, options = {}) => {
            (0, common_1.assertParamExists)("getCustomUnitLabelSubtasksForJob", "dpId", dpId);
            const localVarPath = `/v1/custom-unit-labels/{dpId}`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getKittingInstructions: async (dpId, dsku, options = {}) => {
            (0, common_1.assertParamExists)("getKittingInstructions", "dpId", dpId);
            (0, common_1.assertParamExists)("getKittingInstructions", "dsku", dsku);
            const localVarPath = `/v1/kitting/prep-job/{dpId}/instructions/{dsku}`
                .replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)))
                .replace(`{${"dsku"}}`, encodeURIComponent(String(dsku)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPalletLabelDownloadUrl: async (dpId, options = {}) => {
            (0, common_1.assertParamExists)("getPalletLabelDownloadUrl", "dpId", dpId);
            const localVarPath = `/v1/pallet-label/prep-job/{dpId}/url`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPrepJobByDpId: async (dpId, withDetails, options = {}) => {
            (0, common_1.assertParamExists)("getPrepJobByDpId", "dpId", dpId);
            const localVarPath = `/v1/prep-job/by-dpid/{dpId}`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (withDetails) {
                localVarQueryParameter["withDetails"] = withDetails;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPrepJobBySellerAndSource: async (sellerId, sourceType, sourceId, withDetails, options = {}) => {
            (0, common_1.assertParamExists)("getPrepJobBySellerAndSource", "sellerId", sellerId);
            (0, common_1.assertParamExists)("getPrepJobBySellerAndSource", "sourceType", sourceType);
            (0, common_1.assertParamExists)("getPrepJobBySellerAndSource", "sourceId", sourceId);
            const localVarPath = `/v1/prep-job/by-source/{sellerId}/{sourceType}/{sourceId}`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
                .replace(`{${"sourceType"}}`, encodeURIComponent(String(sourceType)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (withDetails) {
                localVarQueryParameter["withDetails"] = withDetails;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPrepJobMetadata: async (dpId, options = {}) => {
            (0, common_1.assertParamExists)("getPrepJobMetadata", "dpId", dpId);
            const localVarPath = `/v1/prep-job/{dpId}/metadata`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPrepJobsByDpIds: async (dpId, options = {}) => {
            (0, common_1.assertParamExists)("getPrepJobsByDpIds", "dpId", dpId);
            const localVarPath = `/v1/prep-job/by-dpids`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (dpId) {
                localVarQueryParameter["dpId"] = dpId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPrepJobsForFacility: async (facilityId, stage, hideAdminTestSellers, options = {}) => {
            (0, common_1.assertParamExists)("getPrepJobsForFacility", "facilityId", facilityId);
            const localVarPath = `/v1/prep-jobs/facility/{facilityId}`.replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (stage !== undefined) {
                localVarQueryParameter["stage"] = stage;
            }
            if (hideAdminTestSellers !== undefined) {
                localVarQueryParameter["hideAdminTestSellers"] = hideAdminTestSellers;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPrepReserveStorageLabelForWholesaleShipment: async (wholesaleShipmentId, options = {}) => {
            (0, common_1.assertParamExists)("getPrepReserveStorageLabelForWholesaleShipment", "wholesaleShipmentId", wholesaleShipmentId);
            const localVarPath = `/v1/wholesale/shipment-id/{wholesaleShipmentId}/reserve-storage-label`.replace(`{${"wholesaleShipmentId"}}`, encodeURIComponent(String(wholesaleShipmentId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getShippingPlanSelfServePrepForJob: async (sellerId, shippingPlanId, options = {}) => {
            (0, common_1.assertParamExists)("getShippingPlanSelfServePrepForJob", "sellerId", sellerId);
            (0, common_1.assertParamExists)("getShippingPlanSelfServePrepForJob", "shippingPlanId", shippingPlanId);
            const localVarPath = `/v1/prep-job/self-serve/{sellerId}/shipping-plan/{shippingPlanId}`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
                .replace(`{${"shippingPlanId"}}`, encodeURIComponent(String(shippingPlanId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getTodoPrepJobsForFacility: async (facilityId, hideAdminTestSellers, options = {}) => {
            (0, common_1.assertParamExists)("getTodoPrepJobsForFacility", "facilityId", facilityId);
            const localVarPath = `/v1/prep-jobs/facility/{facilityId}/todo/count`.replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (hideAdminTestSellers !== undefined) {
                localVarQueryParameter["hideAdminTestSellers"] = hideAdminTestSellers;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getUnitLabelPrintJobsByDpId: async (dpId, options = {}) => {
            (0, common_1.assertParamExists)("getUnitLabelPrintJobsByDpId", "dpId", dpId);
            const localVarPath = `/v1/unit-labels/prep-job/{dpId}`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        initializeBoxConfiguration: async (dpId, options = {}) => {
            (0, common_1.assertParamExists)("initializeBoxConfiguration", "dpId", dpId);
            const localVarPath = `/v1/box-configuration/prep-job/{dpId}`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        movePrepJob: async (dpId, movePrepJobRequest, options = {}) => {
            (0, common_1.assertParamExists)("movePrepJob", "dpId", dpId);
            (0, common_1.assertParamExists)("movePrepJob", "movePrepJobRequest", movePrepJobRequest);
            const localVarPath = `/v1/prep-job/{dpId}/move`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(movePrepJobRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        receivePrepJob: async (dpId, receivePrepJobRequest, options = {}) => {
            (0, common_1.assertParamExists)("receivePrepJob", "dpId", dpId);
            (0, common_1.assertParamExists)("receivePrepJob", "receivePrepJobRequest", receivePrepJobRequest);
            const localVarPath = `/v1/prep-job/{dpId}/receive`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(receivePrepJobRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        redirectCartonLabelDownloadToPresignedS3Url: async (dpId, type, name, options = {}) => {
            (0, common_1.assertParamExists)("redirectCartonLabelDownloadToPresignedS3Url", "dpId", dpId);
            (0, common_1.assertParamExists)("redirectCartonLabelDownloadToPresignedS3Url", "type", type);
            const localVarPath = `/v1/carton-label/prep-job/{dpId}`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter["type"] = type;
            }
            if (name !== undefined) {
                localVarQueryParameter["name"] = name;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        removeKitFromJob: async (dpId, kittingUuid, options = {}) => {
            (0, common_1.assertParamExists)("removeKitFromJob", "dpId", dpId);
            (0, common_1.assertParamExists)("removeKitFromJob", "kittingUuid", kittingUuid);
            const localVarPath = `/v1/kitting/{kittingUuid}/prep-job/{dpId}`
                .replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)))
                .replace(`{${"kittingUuid"}}`, encodeURIComponent(String(kittingUuid)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "DELETE" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        removePrepComboFromJob: async (dpId, prepCombo, options = {}) => {
            (0, common_1.assertParamExists)("removePrepComboFromJob", "dpId", dpId);
            (0, common_1.assertParamExists)("removePrepComboFromJob", "prepCombo", prepCombo);
            const localVarPath = `/v1/prep-job/{dpId}/combo`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "DELETE" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (prepCombo !== undefined) {
                localVarQueryParameter["prepCombo"] = prepCombo;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        removePrepTypesFromJob: async (dpId, prepType, options = {}) => {
            (0, common_1.assertParamExists)("removePrepTypesFromJob", "dpId", dpId);
            (0, common_1.assertParamExists)("removePrepTypesFromJob", "prepType", prepType);
            const localVarPath = `/v1/prep-job/{dpId}/item`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "DELETE" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (prepType) {
                localVarQueryParameter["prepType"] = prepType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        reportPrepJobNonCompliance: async (dpId, options = {}) => {
            (0, common_1.assertParamExists)("reportPrepJobNonCompliance", "dpId", dpId);
            const localVarPath = `/v1/non-compliance/prep-job/{dpId}`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        resolvePrepJobNonCompliance: async (dpId, options = {}) => {
            (0, common_1.assertParamExists)("resolvePrepJobNonCompliance", "dpId", dpId);
            const localVarPath = `/v1/non-compliance/prep-job/{dpId}/resolve`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        scanBarcode: async (dpId, boxConfigurationUuid, boxConfigurationBarcodeScanRequest, options = {}) => {
            (0, common_1.assertParamExists)("scanBarcode", "dpId", dpId);
            (0, common_1.assertParamExists)("scanBarcode", "boxConfigurationUuid", boxConfigurationUuid);
            (0, common_1.assertParamExists)("scanBarcode", "boxConfigurationBarcodeScanRequest", boxConfigurationBarcodeScanRequest);
            const localVarPath = `/v1/box-configuration/{boxConfigurationUuid}/prep-job/{dpId}/scan`
                .replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)))
                .replace(`{${"boxConfigurationUuid"}}`, encodeURIComponent(String(boxConfigurationUuid)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(boxConfigurationBarcodeScanRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setPalletQuantity: async (dpId, updatePalletQuantityRequest, options = {}) => {
            (0, common_1.assertParamExists)("setPalletQuantity", "dpId", dpId);
            (0, common_1.assertParamExists)("setPalletQuantity", "updatePalletQuantityRequest", updatePalletQuantityRequest);
            const localVarPath = `/v1/pallet-label/prep-job/{dpId}/quantity`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePalletQuantityRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        startPrepJob: async (dpId, startPrepJobRequest, options = {}) => {
            (0, common_1.assertParamExists)("startPrepJob", "dpId", dpId);
            (0, common_1.assertParamExists)("startPrepJob", "startPrepJobRequest", startPrepJobRequest);
            const localVarPath = `/v1/prep-job/{dpId}/start`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(startPrepJobRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        translateBarcode: async (dpId, barcodeTranslationRequest, options = {}) => {
            (0, common_1.assertParamExists)("translateBarcode", "dpId", dpId);
            (0, common_1.assertParamExists)("translateBarcode", "barcodeTranslationRequest", barcodeTranslationRequest);
            const localVarPath = `/v1/barcode-translation/prep-job/{dpId}/scan`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(barcodeTranslationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        undoPrepJobCompletion: async (dpId, options = {}) => {
            (0, common_1.assertParamExists)("undoPrepJobCompletion", "dpId", dpId);
            const localVarPath = `/v1/prep-job/{dpId}/undo-completion`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateBoxConfigurationItem: async (dpId, boxConfigurationUuid, dsku, boxConfigurationItemUpdateRequest, options = {}) => {
            (0, common_1.assertParamExists)("updateBoxConfigurationItem", "dpId", dpId);
            (0, common_1.assertParamExists)("updateBoxConfigurationItem", "boxConfigurationUuid", boxConfigurationUuid);
            (0, common_1.assertParamExists)("updateBoxConfigurationItem", "dsku", dsku);
            (0, common_1.assertParamExists)("updateBoxConfigurationItem", "boxConfigurationItemUpdateRequest", boxConfigurationItemUpdateRequest);
            const localVarPath = `/v1/box-configuration/{boxConfigurationUuid}/prep-job/{dpId}/item/{dsku}`
                .replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)))
                .replace(`{${"boxConfigurationUuid"}}`, encodeURIComponent(String(boxConfigurationUuid)))
                .replace(`{${"dsku"}}`, encodeURIComponent(String(dsku)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(boxConfigurationItemUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateLotFefoDataForUnitLabel: async (dpId, uuid, lotFefoRequest, options = {}) => {
            (0, common_1.assertParamExists)("updateLotFefoDataForUnitLabel", "dpId", dpId);
            (0, common_1.assertParamExists)("updateLotFefoDataForUnitLabel", "uuid", uuid);
            (0, common_1.assertParamExists)("updateLotFefoDataForUnitLabel", "lotFefoRequest", lotFefoRequest);
            const localVarPath = `/v1/unit-labels/prep-job/{dpId}/{uuid}/lot-fefo`
                .replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(lotFefoRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updatePrepJobDestination: async (dpId, updateDestinationRequest, options = {}) => {
            (0, common_1.assertParamExists)("updatePrepJobDestination", "dpId", dpId);
            (0, common_1.assertParamExists)("updatePrepJobDestination", "updateDestinationRequest", updateDestinationRequest);
            const localVarPath = `/v1/prep-job/{dpId}/destination`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDestinationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updatePrepJobNote: async (dpId, updatePrepNoteRequest, options = {}) => {
            (0, common_1.assertParamExists)("updatePrepJobNote", "dpId", dpId);
            (0, common_1.assertParamExists)("updatePrepJobNote", "updatePrepNoteRequest", updatePrepNoteRequest);
            const localVarPath = `/v1/prep-job/{dpId}/note`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePrepNoteRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updatePrepTaskSubtype: async (dpId, updatePrepSubtypeRequest, options = {}) => {
            (0, common_1.assertParamExists)("updatePrepTaskSubtype", "dpId", dpId);
            (0, common_1.assertParamExists)("updatePrepTaskSubtype", "updatePrepSubtypeRequest", updatePrepSubtypeRequest);
            const localVarPath = `/v1/prep-job/{dpId}/task/subtype`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePrepSubtypeRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateShippingPlanSelfServePrepForJob: async (sellerId, shippingPlanId, shippingPlanSelfServePrepRequest, options = {}) => {
            (0, common_1.assertParamExists)("updateShippingPlanSelfServePrepForJob", "sellerId", sellerId);
            (0, common_1.assertParamExists)("updateShippingPlanSelfServePrepForJob", "shippingPlanId", shippingPlanId);
            (0, common_1.assertParamExists)("updateShippingPlanSelfServePrepForJob", "shippingPlanSelfServePrepRequest", shippingPlanSelfServePrepRequest);
            const localVarPath = `/v1/prep-job/self-serve/{sellerId}/shipping-plan/{shippingPlanId}`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
                .replace(`{${"shippingPlanId"}}`, encodeURIComponent(String(shippingPlanId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shippingPlanSelfServePrepRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateSimplePrepForJob: async (sellerId, sourceType, sourceId, simplePrepJobRequest, options = {}) => {
            (0, common_1.assertParamExists)("updateSimplePrepForJob", "sellerId", sellerId);
            (0, common_1.assertParamExists)("updateSimplePrepForJob", "sourceType", sourceType);
            (0, common_1.assertParamExists)("updateSimplePrepForJob", "sourceId", sourceId);
            (0, common_1.assertParamExists)("updateSimplePrepForJob", "simplePrepJobRequest", simplePrepJobRequest);
            const localVarPath = `/v1/prep-job/simple/{sellerId}/{sourceType}/{sourceId}`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
                .replace(`{${"sourceType"}}`, encodeURIComponent(String(sourceType)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(simplePrepJobRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateWholesaleShipmentSelfServePrepForJob: async (sellerId, wholesaleShipmentId, wholesaleSelfServePrepRequest, options = {}) => {
            (0, common_1.assertParamExists)("updateWholesaleShipmentSelfServePrepForJob", "sellerId", sellerId);
            (0, common_1.assertParamExists)("updateWholesaleShipmentSelfServePrepForJob", "wholesaleShipmentId", wholesaleShipmentId);
            (0, common_1.assertParamExists)("updateWholesaleShipmentSelfServePrepForJob", "wholesaleSelfServePrepRequest", wholesaleSelfServePrepRequest);
            const localVarPath = `/v1/prep-job/self-serve/{sellerId}/wholesale-shipment/{wholesaleShipmentId}`
                .replace(`{${"sellerId"}}`, encodeURIComponent(String(sellerId)))
                .replace(`{${"wholesaleShipmentId"}}`, encodeURIComponent(String(wholesaleShipmentId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(wholesaleSelfServePrepRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadCartonLabel: async (dpId, cartonLabelUploadUsingUrlRequest, options = {}) => {
            (0, common_1.assertParamExists)("uploadCartonLabel", "dpId", dpId);
            (0, common_1.assertParamExists)("uploadCartonLabel", "cartonLabelUploadUsingUrlRequest", cartonLabelUploadUsingUrlRequest);
            const localVarPath = `/v1/carton-label/prep-job/{dpId}`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cartonLabelUploadUsingUrlRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadPalletLabel: async (dpId, palletLabelUploadRequest, options = {}) => {
            (0, common_1.assertParamExists)("uploadPalletLabel", "dpId", dpId);
            (0, common_1.assertParamExists)("uploadPalletLabel", "palletLabelUploadRequest", palletLabelUploadRequest);
            const localVarPath = `/v1/pallet-label/prep-job/{dpId}`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(palletLabelUploadRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        validateLocationForPrepJob: async (dpId, action, location, options = {}) => {
            (0, common_1.assertParamExists)("validateLocationForPrepJob", "dpId", dpId);
            (0, common_1.assertParamExists)("validateLocationForPrepJob", "action", action);
            (0, common_1.assertParamExists)("validateLocationForPrepJob", "location", location);
            const localVarPath = `/v1/prep-job/{dpId}/location-validation`.replace(`{${"dpId"}}`, encodeURIComponent(String(dpId)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (action !== undefined) {
                localVarQueryParameter["action"] = action;
            }
            if (location !== undefined) {
                localVarQueryParameter["location"] = location;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ServiceApiAxiosParamCreator = ServiceApiAxiosParamCreator;
const ServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ServiceApiAxiosParamCreator)(configuration);
    return {
        async addCustomUnitLabelSubtasksForJob(dpId, customUnitLabelSubtaskRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCustomUnitLabelSubtasksForJob(dpId, customUnitLabelSubtaskRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async addFloorLoadedContainerForSourceTypeAndId(sourceType, sourceId, floorLoadedContainerRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFloorLoadedContainerForSourceTypeAndId(sourceType, sourceId, floorLoadedContainerRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async addKitsByShippingPlan(sellerId, shippingPlanId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addKitsByShippingPlan(sellerId, shippingPlanId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async addKitsToJob(dpId, kittingRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addKitsToJob(dpId, kittingRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async addPrepTypesToJob(prepJobRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPrepTypesToJob(prepJobRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async archiveFacilityJobLocation(facilityId, location, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveFacilityJobLocation(facilityId, location, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async archivePrepJob(dpId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archivePrepJob(dpId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async batchManualBilling(manualBillingRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchManualBilling(manualBillingRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async completeBoxBuild(dpId, completeBoxBuildRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeBoxBuild(dpId, completeBoxBuildRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async completeKitFromJob(dpId, kittingUuid, kittingCompletionRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeKitFromJob(dpId, kittingUuid, kittingCompletionRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async completePrepJob(dpId, completePrepJobRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completePrepJob(dpId, completePrepJobRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async completePrepTask(dpId, completePrepTaskRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completePrepTask(dpId, completePrepTaskRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createBarcodeTranslationMap(sellerId, createBarcodeTranslationMapRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBarcodeTranslationMap(sellerId, createBarcodeTranslationMapRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async createFacilityJobLocation(facilityId, facilityJobLocationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFacilityJobLocation(facilityId, facilityJobLocationRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async downloadBoxContentLabels(dpId, boxConfigurationUuid, labelFormat, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBoxContentLabels(dpId, boxConfigurationUuid, labelFormat, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async enableLotFefoForUnitLabels(dpId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableLotFefoForUnitLabels(dpId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async finalizeBoxConfiguration(dpId, boxConfigurationUuid, boxConfigurationFinalizationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finalizeBoxConfiguration(dpId, boxConfigurationUuid, boxConfigurationFinalizationRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generatePDFBarcodeTranslation(dpId, barcodeTranslationUuid, printUnitLabelRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePDFBarcodeTranslation(dpId, barcodeTranslationUuid, printUnitLabelRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generatePDFUnitLabels(dpId, uuid, labelFormat, quantity, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePDFUnitLabels(dpId, uuid, labelFormat, quantity, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateZPLBarcodeTranslation(dpId, barcodeTranslationUuid, printUnitLabelRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateZPLBarcodeTranslation(dpId, barcodeTranslationUuid, printUnitLabelRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async generateZPLUnitLabels(dpId, uuid, labelFormat, quantity, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateZPLUnitLabels(dpId, uuid, labelFormat, quantity, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getBoxConfigurations(dpId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoxConfigurations(dpId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getCartonLabelDownloadUrl(dpId, type, name, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCartonLabelDownloadUrl(dpId, type, name, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getCustomUnitLabelSubtasksForJob(dpId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomUnitLabelSubtasksForJob(dpId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getKittingInstructions(dpId, dsku, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKittingInstructions(dpId, dsku, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPalletLabelDownloadUrl(dpId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPalletLabelDownloadUrl(dpId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPrepJobByDpId(dpId, withDetails, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrepJobByDpId(dpId, withDetails, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPrepJobBySellerAndSource(sellerId, sourceType, sourceId, withDetails, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrepJobBySellerAndSource(sellerId, sourceType, sourceId, withDetails, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPrepJobMetadata(dpId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrepJobMetadata(dpId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPrepJobsByDpIds(dpId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrepJobsByDpIds(dpId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPrepJobsForFacility(facilityId, stage, hideAdminTestSellers, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrepJobsForFacility(facilityId, stage, hideAdminTestSellers, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPrepReserveStorageLabelForWholesaleShipment(wholesaleShipmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrepReserveStorageLabelForWholesaleShipment(wholesaleShipmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getTodoPrepJobsForFacility(facilityId, hideAdminTestSellers, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTodoPrepJobsForFacility(facilityId, hideAdminTestSellers, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getUnitLabelPrintJobsByDpId(dpId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnitLabelPrintJobsByDpId(dpId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async initializeBoxConfiguration(dpId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initializeBoxConfiguration(dpId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async movePrepJob(dpId, movePrepJobRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.movePrepJob(dpId, movePrepJobRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async receivePrepJob(dpId, receivePrepJobRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receivePrepJob(dpId, receivePrepJobRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async redirectCartonLabelDownloadToPresignedS3Url(dpId, type, name, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redirectCartonLabelDownloadToPresignedS3Url(dpId, type, name, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async removeKitFromJob(dpId, kittingUuid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeKitFromJob(dpId, kittingUuid, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async removePrepComboFromJob(dpId, prepCombo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePrepComboFromJob(dpId, prepCombo, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async removePrepTypesFromJob(dpId, prepType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePrepTypesFromJob(dpId, prepType, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async reportPrepJobNonCompliance(dpId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportPrepJobNonCompliance(dpId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async resolvePrepJobNonCompliance(dpId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolvePrepJobNonCompliance(dpId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async scanBarcode(dpId, boxConfigurationUuid, boxConfigurationBarcodeScanRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scanBarcode(dpId, boxConfigurationUuid, boxConfigurationBarcodeScanRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async setPalletQuantity(dpId, updatePalletQuantityRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPalletQuantity(dpId, updatePalletQuantityRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async startPrepJob(dpId, startPrepJobRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startPrepJob(dpId, startPrepJobRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async translateBarcode(dpId, barcodeTranslationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.translateBarcode(dpId, barcodeTranslationRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async undoPrepJobCompletion(dpId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoPrepJobCompletion(dpId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateBoxConfigurationItem(dpId, boxConfigurationUuid, dsku, boxConfigurationItemUpdateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBoxConfigurationItem(dpId, boxConfigurationUuid, dsku, boxConfigurationItemUpdateRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateLotFefoDataForUnitLabel(dpId, uuid, lotFefoRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLotFefoDataForUnitLabel(dpId, uuid, lotFefoRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updatePrepJobDestination(dpId, updateDestinationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrepJobDestination(dpId, updateDestinationRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updatePrepJobNote(dpId, updatePrepNoteRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrepJobNote(dpId, updatePrepNoteRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updatePrepTaskSubtype(dpId, updatePrepSubtypeRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrepTaskSubtype(dpId, updatePrepSubtypeRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, shippingPlanSelfServePrepRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, shippingPlanSelfServePrepRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateSimplePrepForJob(sellerId, sourceType, sourceId, simplePrepJobRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSimplePrepForJob(sellerId, sourceType, sourceId, simplePrepJobRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updateWholesaleShipmentSelfServePrepForJob(sellerId, wholesaleShipmentId, wholesaleSelfServePrepRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWholesaleShipmentSelfServePrepForJob(sellerId, wholesaleShipmentId, wholesaleSelfServePrepRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async uploadCartonLabel(dpId, cartonLabelUploadUsingUrlRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCartonLabel(dpId, cartonLabelUploadUsingUrlRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async uploadPalletLabel(dpId, palletLabelUploadRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPalletLabel(dpId, palletLabelUploadRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async validateLocationForPrepJob(dpId, action, location, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateLocationForPrepJob(dpId, action, location, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.ServiceApiFp = ServiceApiFp;
const ServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ServiceApiFp)(configuration);
    return {
        addCustomUnitLabelSubtasksForJob(dpId, customUnitLabelSubtaskRequest, options) {
            return localVarFp
                .addCustomUnitLabelSubtasksForJob(dpId, customUnitLabelSubtaskRequest, options)
                .then((request) => request(axios, basePath));
        },
        addFloorLoadedContainerForSourceTypeAndId(sourceType, sourceId, floorLoadedContainerRequest, options) {
            return localVarFp
                .addFloorLoadedContainerForSourceTypeAndId(sourceType, sourceId, floorLoadedContainerRequest, options)
                .then((request) => request(axios, basePath));
        },
        addKitsByShippingPlan(sellerId, shippingPlanId, options) {
            return localVarFp
                .addKitsByShippingPlan(sellerId, shippingPlanId, options)
                .then((request) => request(axios, basePath));
        },
        addKitsToJob(dpId, kittingRequest, options) {
            return localVarFp.addKitsToJob(dpId, kittingRequest, options).then((request) => request(axios, basePath));
        },
        addPrepTypesToJob(prepJobRequest, options) {
            return localVarFp.addPrepTypesToJob(prepJobRequest, options).then((request) => request(axios, basePath));
        },
        archiveFacilityJobLocation(facilityId, location, options) {
            return localVarFp
                .archiveFacilityJobLocation(facilityId, location, options)
                .then((request) => request(axios, basePath));
        },
        archivePrepJob(dpId, options) {
            return localVarFp.archivePrepJob(dpId, options).then((request) => request(axios, basePath));
        },
        batchManualBilling(manualBillingRequest, options) {
            return localVarFp.batchManualBilling(manualBillingRequest, options).then((request) => request(axios, basePath));
        },
        completeBoxBuild(dpId, completeBoxBuildRequest, options) {
            return localVarFp
                .completeBoxBuild(dpId, completeBoxBuildRequest, options)
                .then((request) => request(axios, basePath));
        },
        completeKitFromJob(dpId, kittingUuid, kittingCompletionRequest, options) {
            return localVarFp
                .completeKitFromJob(dpId, kittingUuid, kittingCompletionRequest, options)
                .then((request) => request(axios, basePath));
        },
        completePrepJob(dpId, completePrepJobRequest, options) {
            return localVarFp
                .completePrepJob(dpId, completePrepJobRequest, options)
                .then((request) => request(axios, basePath));
        },
        completePrepTask(dpId, completePrepTaskRequest, options) {
            return localVarFp
                .completePrepTask(dpId, completePrepTaskRequest, options)
                .then((request) => request(axios, basePath));
        },
        createBarcodeTranslationMap(sellerId, createBarcodeTranslationMapRequest, options) {
            return localVarFp
                .createBarcodeTranslationMap(sellerId, createBarcodeTranslationMapRequest, options)
                .then((request) => request(axios, basePath));
        },
        createFacilityJobLocation(facilityId, facilityJobLocationRequest, options) {
            return localVarFp
                .createFacilityJobLocation(facilityId, facilityJobLocationRequest, options)
                .then((request) => request(axios, basePath));
        },
        downloadBoxContentLabels(dpId, boxConfigurationUuid, labelFormat, options) {
            return localVarFp
                .downloadBoxContentLabels(dpId, boxConfigurationUuid, labelFormat, options)
                .then((request) => request(axios, basePath));
        },
        enableLotFefoForUnitLabels(dpId, options) {
            return localVarFp.enableLotFefoForUnitLabels(dpId, options).then((request) => request(axios, basePath));
        },
        finalizeBoxConfiguration(dpId, boxConfigurationUuid, boxConfigurationFinalizationRequest, options) {
            return localVarFp
                .finalizeBoxConfiguration(dpId, boxConfigurationUuid, boxConfigurationFinalizationRequest, options)
                .then((request) => request(axios, basePath));
        },
        generatePDFBarcodeTranslation(dpId, barcodeTranslationUuid, printUnitLabelRequest, options) {
            return localVarFp
                .generatePDFBarcodeTranslation(dpId, barcodeTranslationUuid, printUnitLabelRequest, options)
                .then((request) => request(axios, basePath));
        },
        generatePDFUnitLabels(dpId, uuid, labelFormat, quantity, options) {
            return localVarFp
                .generatePDFUnitLabels(dpId, uuid, labelFormat, quantity, options)
                .then((request) => request(axios, basePath));
        },
        generateZPLBarcodeTranslation(dpId, barcodeTranslationUuid, printUnitLabelRequest, options) {
            return localVarFp
                .generateZPLBarcodeTranslation(dpId, barcodeTranslationUuid, printUnitLabelRequest, options)
                .then((request) => request(axios, basePath));
        },
        generateZPLUnitLabels(dpId, uuid, labelFormat, quantity, options) {
            return localVarFp
                .generateZPLUnitLabels(dpId, uuid, labelFormat, quantity, options)
                .then((request) => request(axios, basePath));
        },
        getBoxConfigurations(dpId, options) {
            return localVarFp.getBoxConfigurations(dpId, options).then((request) => request(axios, basePath));
        },
        getCartonLabelDownloadUrl(dpId, type, name, options) {
            return localVarFp
                .getCartonLabelDownloadUrl(dpId, type, name, options)
                .then((request) => request(axios, basePath));
        },
        getCustomUnitLabelSubtasksForJob(dpId, options) {
            return localVarFp.getCustomUnitLabelSubtasksForJob(dpId, options).then((request) => request(axios, basePath));
        },
        getKittingInstructions(dpId, dsku, options) {
            return localVarFp.getKittingInstructions(dpId, dsku, options).then((request) => request(axios, basePath));
        },
        getPalletLabelDownloadUrl(dpId, options) {
            return localVarFp.getPalletLabelDownloadUrl(dpId, options).then((request) => request(axios, basePath));
        },
        getPrepJobByDpId(dpId, withDetails, options) {
            return localVarFp.getPrepJobByDpId(dpId, withDetails, options).then((request) => request(axios, basePath));
        },
        getPrepJobBySellerAndSource(sellerId, sourceType, sourceId, withDetails, options) {
            return localVarFp
                .getPrepJobBySellerAndSource(sellerId, sourceType, sourceId, withDetails, options)
                .then((request) => request(axios, basePath));
        },
        getPrepJobMetadata(dpId, options) {
            return localVarFp.getPrepJobMetadata(dpId, options).then((request) => request(axios, basePath));
        },
        getPrepJobsByDpIds(dpId, options) {
            return localVarFp.getPrepJobsByDpIds(dpId, options).then((request) => request(axios, basePath));
        },
        getPrepJobsForFacility(facilityId, stage, hideAdminTestSellers, options) {
            return localVarFp
                .getPrepJobsForFacility(facilityId, stage, hideAdminTestSellers, options)
                .then((request) => request(axios, basePath));
        },
        getPrepReserveStorageLabelForWholesaleShipment(wholesaleShipmentId, options) {
            return localVarFp
                .getPrepReserveStorageLabelForWholesaleShipment(wholesaleShipmentId, options)
                .then((request) => request(axios, basePath));
        },
        getShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, options) {
            return localVarFp
                .getShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, options)
                .then((request) => request(axios, basePath));
        },
        getTodoPrepJobsForFacility(facilityId, hideAdminTestSellers, options) {
            return localVarFp
                .getTodoPrepJobsForFacility(facilityId, hideAdminTestSellers, options)
                .then((request) => request(axios, basePath));
        },
        getUnitLabelPrintJobsByDpId(dpId, options) {
            return localVarFp.getUnitLabelPrintJobsByDpId(dpId, options).then((request) => request(axios, basePath));
        },
        initializeBoxConfiguration(dpId, options) {
            return localVarFp.initializeBoxConfiguration(dpId, options).then((request) => request(axios, basePath));
        },
        movePrepJob(dpId, movePrepJobRequest, options) {
            return localVarFp.movePrepJob(dpId, movePrepJobRequest, options).then((request) => request(axios, basePath));
        },
        receivePrepJob(dpId, receivePrepJobRequest, options) {
            return localVarFp
                .receivePrepJob(dpId, receivePrepJobRequest, options)
                .then((request) => request(axios, basePath));
        },
        redirectCartonLabelDownloadToPresignedS3Url(dpId, type, name, options) {
            return localVarFp
                .redirectCartonLabelDownloadToPresignedS3Url(dpId, type, name, options)
                .then((request) => request(axios, basePath));
        },
        removeKitFromJob(dpId, kittingUuid, options) {
            return localVarFp.removeKitFromJob(dpId, kittingUuid, options).then((request) => request(axios, basePath));
        },
        removePrepComboFromJob(dpId, prepCombo, options) {
            return localVarFp.removePrepComboFromJob(dpId, prepCombo, options).then((request) => request(axios, basePath));
        },
        removePrepTypesFromJob(dpId, prepType, options) {
            return localVarFp.removePrepTypesFromJob(dpId, prepType, options).then((request) => request(axios, basePath));
        },
        reportPrepJobNonCompliance(dpId, options) {
            return localVarFp.reportPrepJobNonCompliance(dpId, options).then((request) => request(axios, basePath));
        },
        resolvePrepJobNonCompliance(dpId, options) {
            return localVarFp.resolvePrepJobNonCompliance(dpId, options).then((request) => request(axios, basePath));
        },
        scanBarcode(dpId, boxConfigurationUuid, boxConfigurationBarcodeScanRequest, options) {
            return localVarFp
                .scanBarcode(dpId, boxConfigurationUuid, boxConfigurationBarcodeScanRequest, options)
                .then((request) => request(axios, basePath));
        },
        setPalletQuantity(dpId, updatePalletQuantityRequest, options) {
            return localVarFp
                .setPalletQuantity(dpId, updatePalletQuantityRequest, options)
                .then((request) => request(axios, basePath));
        },
        startPrepJob(dpId, startPrepJobRequest, options) {
            return localVarFp.startPrepJob(dpId, startPrepJobRequest, options).then((request) => request(axios, basePath));
        },
        translateBarcode(dpId, barcodeTranslationRequest, options) {
            return localVarFp
                .translateBarcode(dpId, barcodeTranslationRequest, options)
                .then((request) => request(axios, basePath));
        },
        undoPrepJobCompletion(dpId, options) {
            return localVarFp.undoPrepJobCompletion(dpId, options).then((request) => request(axios, basePath));
        },
        updateBoxConfigurationItem(dpId, boxConfigurationUuid, dsku, boxConfigurationItemUpdateRequest, options) {
            return localVarFp
                .updateBoxConfigurationItem(dpId, boxConfigurationUuid, dsku, boxConfigurationItemUpdateRequest, options)
                .then((request) => request(axios, basePath));
        },
        updateLotFefoDataForUnitLabel(dpId, uuid, lotFefoRequest, options) {
            return localVarFp
                .updateLotFefoDataForUnitLabel(dpId, uuid, lotFefoRequest, options)
                .then((request) => request(axios, basePath));
        },
        updatePrepJobDestination(dpId, updateDestinationRequest, options) {
            return localVarFp
                .updatePrepJobDestination(dpId, updateDestinationRequest, options)
                .then((request) => request(axios, basePath));
        },
        updatePrepJobNote(dpId, updatePrepNoteRequest, options) {
            return localVarFp
                .updatePrepJobNote(dpId, updatePrepNoteRequest, options)
                .then((request) => request(axios, basePath));
        },
        updatePrepTaskSubtype(dpId, updatePrepSubtypeRequest, options) {
            return localVarFp
                .updatePrepTaskSubtype(dpId, updatePrepSubtypeRequest, options)
                .then((request) => request(axios, basePath));
        },
        updateShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, shippingPlanSelfServePrepRequest, options) {
            return localVarFp
                .updateShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, shippingPlanSelfServePrepRequest, options)
                .then((request) => request(axios, basePath));
        },
        updateSimplePrepForJob(sellerId, sourceType, sourceId, simplePrepJobRequest, options) {
            return localVarFp
                .updateSimplePrepForJob(sellerId, sourceType, sourceId, simplePrepJobRequest, options)
                .then((request) => request(axios, basePath));
        },
        updateWholesaleShipmentSelfServePrepForJob(sellerId, wholesaleShipmentId, wholesaleSelfServePrepRequest, options) {
            return localVarFp
                .updateWholesaleShipmentSelfServePrepForJob(sellerId, wholesaleShipmentId, wholesaleSelfServePrepRequest, options)
                .then((request) => request(axios, basePath));
        },
        uploadCartonLabel(dpId, cartonLabelUploadUsingUrlRequest, options) {
            return localVarFp
                .uploadCartonLabel(dpId, cartonLabelUploadUsingUrlRequest, options)
                .then((request) => request(axios, basePath));
        },
        uploadPalletLabel(dpId, palletLabelUploadRequest, options) {
            return localVarFp
                .uploadPalletLabel(dpId, palletLabelUploadRequest, options)
                .then((request) => request(axios, basePath));
        },
        validateLocationForPrepJob(dpId, action, location, options) {
            return localVarFp
                .validateLocationForPrepJob(dpId, action, location, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.ServiceApiFactory = ServiceApiFactory;
class ServiceApi extends base_1.BaseAPI {
    addCustomUnitLabelSubtasksForJob(dpId, customUnitLabelSubtaskRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .addCustomUnitLabelSubtasksForJob(dpId, customUnitLabelSubtaskRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    addFloorLoadedContainerForSourceTypeAndId(sourceType, sourceId, floorLoadedContainerRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .addFloorLoadedContainerForSourceTypeAndId(sourceType, sourceId, floorLoadedContainerRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    addKitsByShippingPlan(sellerId, shippingPlanId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .addKitsByShippingPlan(sellerId, shippingPlanId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    addKitsToJob(dpId, kittingRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .addKitsToJob(dpId, kittingRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    addPrepTypesToJob(prepJobRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .addPrepTypesToJob(prepJobRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    archiveFacilityJobLocation(facilityId, location, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .archiveFacilityJobLocation(facilityId, location, options)
            .then((request) => request(this.axios, this.basePath));
    }
    archivePrepJob(dpId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .archivePrepJob(dpId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    batchManualBilling(manualBillingRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .batchManualBilling(manualBillingRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    completeBoxBuild(dpId, completeBoxBuildRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .completeBoxBuild(dpId, completeBoxBuildRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    completeKitFromJob(dpId, kittingUuid, kittingCompletionRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .completeKitFromJob(dpId, kittingUuid, kittingCompletionRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    completePrepJob(dpId, completePrepJobRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .completePrepJob(dpId, completePrepJobRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    completePrepTask(dpId, completePrepTaskRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .completePrepTask(dpId, completePrepTaskRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    createBarcodeTranslationMap(sellerId, createBarcodeTranslationMapRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .createBarcodeTranslationMap(sellerId, createBarcodeTranslationMapRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    createFacilityJobLocation(facilityId, facilityJobLocationRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .createFacilityJobLocation(facilityId, facilityJobLocationRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    downloadBoxContentLabels(dpId, boxConfigurationUuid, labelFormat, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .downloadBoxContentLabels(dpId, boxConfigurationUuid, labelFormat, options)
            .then((request) => request(this.axios, this.basePath));
    }
    enableLotFefoForUnitLabels(dpId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .enableLotFefoForUnitLabels(dpId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    finalizeBoxConfiguration(dpId, boxConfigurationUuid, boxConfigurationFinalizationRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .finalizeBoxConfiguration(dpId, boxConfigurationUuid, boxConfigurationFinalizationRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    generatePDFBarcodeTranslation(dpId, barcodeTranslationUuid, printUnitLabelRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .generatePDFBarcodeTranslation(dpId, barcodeTranslationUuid, printUnitLabelRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    generatePDFUnitLabels(dpId, uuid, labelFormat, quantity, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .generatePDFUnitLabels(dpId, uuid, labelFormat, quantity, options)
            .then((request) => request(this.axios, this.basePath));
    }
    generateZPLBarcodeTranslation(dpId, barcodeTranslationUuid, printUnitLabelRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .generateZPLBarcodeTranslation(dpId, barcodeTranslationUuid, printUnitLabelRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    generateZPLUnitLabels(dpId, uuid, labelFormat, quantity, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .generateZPLUnitLabels(dpId, uuid, labelFormat, quantity, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getBoxConfigurations(dpId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getBoxConfigurations(dpId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getCartonLabelDownloadUrl(dpId, type, name, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getCartonLabelDownloadUrl(dpId, type, name, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getCustomUnitLabelSubtasksForJob(dpId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getCustomUnitLabelSubtasksForJob(dpId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getKittingInstructions(dpId, dsku, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getKittingInstructions(dpId, dsku, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getPalletLabelDownloadUrl(dpId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getPalletLabelDownloadUrl(dpId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getPrepJobByDpId(dpId, withDetails, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getPrepJobByDpId(dpId, withDetails, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getPrepJobBySellerAndSource(sellerId, sourceType, sourceId, withDetails, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getPrepJobBySellerAndSource(sellerId, sourceType, sourceId, withDetails, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getPrepJobMetadata(dpId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getPrepJobMetadata(dpId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getPrepJobsByDpIds(dpId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getPrepJobsByDpIds(dpId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getPrepJobsForFacility(facilityId, stage, hideAdminTestSellers, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getPrepJobsForFacility(facilityId, stage, hideAdminTestSellers, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getPrepReserveStorageLabelForWholesaleShipment(wholesaleShipmentId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getPrepReserveStorageLabelForWholesaleShipment(wholesaleShipmentId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getTodoPrepJobsForFacility(facilityId, hideAdminTestSellers, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getTodoPrepJobsForFacility(facilityId, hideAdminTestSellers, options)
            .then((request) => request(this.axios, this.basePath));
    }
    getUnitLabelPrintJobsByDpId(dpId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .getUnitLabelPrintJobsByDpId(dpId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    initializeBoxConfiguration(dpId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .initializeBoxConfiguration(dpId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    movePrepJob(dpId, movePrepJobRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .movePrepJob(dpId, movePrepJobRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    receivePrepJob(dpId, receivePrepJobRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .receivePrepJob(dpId, receivePrepJobRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    redirectCartonLabelDownloadToPresignedS3Url(dpId, type, name, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .redirectCartonLabelDownloadToPresignedS3Url(dpId, type, name, options)
            .then((request) => request(this.axios, this.basePath));
    }
    removeKitFromJob(dpId, kittingUuid, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .removeKitFromJob(dpId, kittingUuid, options)
            .then((request) => request(this.axios, this.basePath));
    }
    removePrepComboFromJob(dpId, prepCombo, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .removePrepComboFromJob(dpId, prepCombo, options)
            .then((request) => request(this.axios, this.basePath));
    }
    removePrepTypesFromJob(dpId, prepType, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .removePrepTypesFromJob(dpId, prepType, options)
            .then((request) => request(this.axios, this.basePath));
    }
    reportPrepJobNonCompliance(dpId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .reportPrepJobNonCompliance(dpId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    resolvePrepJobNonCompliance(dpId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .resolvePrepJobNonCompliance(dpId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    scanBarcode(dpId, boxConfigurationUuid, boxConfigurationBarcodeScanRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .scanBarcode(dpId, boxConfigurationUuid, boxConfigurationBarcodeScanRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    setPalletQuantity(dpId, updatePalletQuantityRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .setPalletQuantity(dpId, updatePalletQuantityRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    startPrepJob(dpId, startPrepJobRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .startPrepJob(dpId, startPrepJobRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    translateBarcode(dpId, barcodeTranslationRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .translateBarcode(dpId, barcodeTranslationRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    undoPrepJobCompletion(dpId, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .undoPrepJobCompletion(dpId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    updateBoxConfigurationItem(dpId, boxConfigurationUuid, dsku, boxConfigurationItemUpdateRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .updateBoxConfigurationItem(dpId, boxConfigurationUuid, dsku, boxConfigurationItemUpdateRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    updateLotFefoDataForUnitLabel(dpId, uuid, lotFefoRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .updateLotFefoDataForUnitLabel(dpId, uuid, lotFefoRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    updatePrepJobDestination(dpId, updateDestinationRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .updatePrepJobDestination(dpId, updateDestinationRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    updatePrepJobNote(dpId, updatePrepNoteRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .updatePrepJobNote(dpId, updatePrepNoteRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    updatePrepTaskSubtype(dpId, updatePrepSubtypeRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .updatePrepTaskSubtype(dpId, updatePrepSubtypeRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    updateShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, shippingPlanSelfServePrepRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .updateShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, shippingPlanSelfServePrepRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    updateSimplePrepForJob(sellerId, sourceType, sourceId, simplePrepJobRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .updateSimplePrepForJob(sellerId, sourceType, sourceId, simplePrepJobRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    updateWholesaleShipmentSelfServePrepForJob(sellerId, wholesaleShipmentId, wholesaleSelfServePrepRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .updateWholesaleShipmentSelfServePrepForJob(sellerId, wholesaleShipmentId, wholesaleSelfServePrepRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    uploadCartonLabel(dpId, cartonLabelUploadUsingUrlRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .uploadCartonLabel(dpId, cartonLabelUploadUsingUrlRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    uploadPalletLabel(dpId, palletLabelUploadRequest, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .uploadPalletLabel(dpId, palletLabelUploadRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    validateLocationForPrepJob(dpId, action, location, options) {
        return (0, exports.ServiceApiFp)(this.configuration)
            .validateLocationForPrepJob(dpId, action, location, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.ServiceApi = ServiceApi;
//# sourceMappingURL=service-api.js.map